// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__Pv_pp g-grid g-grid-container","videoWrapper":"style_videoWrapper__Jzrrq"};